module.exports = __webpack_public_path__ + "img/norway-neoplasm-male.ced7efa8.png";